import axios from "axios";
import global from "../utils/Global";

const ApiClient = axios.create({
  baseURL:  global.baseURL +  '/quoting_api'
});

export default ApiClient;